// extracted by mini-css-extract-plugin
module.exports = {"container":"NoAccessToApp_container__Fr6ZE","iconColor":"NoAccessToApp_iconColor__p/XJU","bold":"NoAccessToApp_bold__EzIgo","light":"NoAccessToApp_light__LjTOB"};